{
  "api_settings_page": {
    "header": {
      "title": "API",
      "description": "The SparkLayer API lets you connect your backend system to send B2B data.",
      "actions": {
        "create": "Create new API Key"
      }
    },
    "table": {
      "headings": {
        "name": "name",
        "client_id": "client id",
        "created": "created"
      },
      "caption": "Table of all your API keys",
      "empty": {
        "title": "No API Keys have been created yet.",
        "body": "Click 'Create new API key' above."
      }
    },
    "docs": {
      "header": "Intergrating with the SparkLayer API",
      "body": "Once you've created your API key, you're ready to begin integrating with the SparkLayer API to start sending data. Or invite your technical partner to your account to get you going with your integration needs.",
      "buttons": {
        "docs": "SparkLayer API Docs",
        "invite": "Invite team members"
      }
    },
    "notifications": {
      "errors": {
        "create_failed": "Something went wrong while creating this API key.",
        "delete_failed": "Something went wrong while deleting this API key."
      }
    }
  }
}
